export const ratesMixin = {
    inheritAttrs: false,
    methods: {
        getWeeklyRatesPlaceholder(strip) {
            if (
                this.ratesData &&
                this.ratesList &&
                this.ratesData.rate_settings.use_weekly_rates
            ) {
                if (strip) {
                    return (
                        this.ratesList.dr.weekly_rate +
                        ' (Default)'
                    );
                } else {
                    return this.ratesList.dr.weekly_rate;
                }
            }
            return 'N/A';
        },
        getMonthlyRatesPlaceholder(strip) {
            if (
                this.ratesData &&
                this.ratesList &&
                this.ratesData.rate_settings.use_monthly_rates
            ) {
                if (strip) {
                    return (
                        this.ratesList.dr.monthly_rate +
                        ' (Default)'
                    );
                } else {
                    return this.ratesList.dr.monthly_rate;
                }
            }
            return 'N/A';
        },     
    },
};
